import React, { useEffect, useState } from "react";
import { usePaygo } from "../../../hooks/usePaygo";

import { Station } from "../../../../stations/types/stations.types";
import FilterButtonDrawer, {
  FilterDrawerContainer,
  FilterStatusItem,
} from "../../../../../common/components/atom/FilterButtonDrawer/FilterButtonDrawer";
import StationPicker from "../../../../stations/components/StationPicker/StationPicker";
import { SingleStation } from "../../../../stations/components/SingleStation";

import { limitString } from "../../../../../utils/string.utils";
import { Organization } from "../../../../organization/types/organization.types";
import OrganizationPicker from "../../../../organization/components/OrganizationPicker/OrganizationPicker";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import { useAuth } from "../../../../auth/hooks";
import ClientPicker from "../../../../clients/components/ClientPicker/ClientPicker";
import { Client } from "../../../../clients/types/clients.types";
import { userRoles } from "../../../../user/types/user.types";

export default function PaygoFilterPresenter() {
  const {
    allPaygoQuery: { currentFilterObject, setFilterObject, removeFromFilter },
  } = usePaygo();
  const [stationFilter, setStationFilter] = useState<Station | undefined>();
  const [userFilter, setUserFilter] = useState<Client | undefined>();
  const [organisationFilter, setOrganisationFilter] = useState<
    Organization | undefined
  >();
  const { userRole } = useAuth();
  useEffect(() => {
    if (userFilter) {
      setFilterObject({
        ...currentFilterObject,
        paygo_client_phone_number: {
          operator: "eq",
          values: [userFilter.client_phone_number as string],
          attribute: "paygo_client_phone_number",
        },
      });
    }
  }, [userFilter]); // eslint-disable-line

  useEffect(() => {
    if (stationFilter) {
      setFilterObject({
        ...currentFilterObject,
        paygo_station: {
          operator: "eq",
          values: [stationFilter.station_id],
          attribute: "paygo_station",
        },
      });
    }
  }, [stationFilter]); // eslint-disable-line

  useEffect(() => {
    if (organisationFilter) {
      setFilterObject({
        ...currentFilterObject,
        organization_id: {
          operator: "eq",
          values: [organisationFilter.organization_id],
          attribute: "organization_id",
        },
      });
    }
  }, [organisationFilter]); // eslint-disable-line
  return (
    <div>
      <FilterButtonDrawer
        label="Filtre"
        childrenRender={({ closeDrawer }) => (
          <FilterDrawerContainer>
            <StationPicker
              placeholder="Entrez une station"
              label="Station"
              setCurrentStation={setStationFilter}
              currentStation={stationFilter}
              style={{ height: 35, width: 250 }}
            />
            <ClientPicker
              label="Numéro de téléphone"
              placeHolder="Entrez un numéro de téléphone"
              searchPlaceholder="Numéro de téléphone, Nom..."
              setClient={setUserFilter}
              style={{ height: 35, width: 250 }}
              currentClient={userFilter}
              textFormat={(user) =>
              {
                if (!user) return "";
                return limitString(
                  "" +
                    (user?.client_lastname|| "")+
                    " " +
                    (user?.client_firstname|| "")+
                    " - " +
                    (user?.client_phone_number|| "Aucun numéro"),
                  20
                )}
              }
             createDefaultItem={(value) => ({
                client_firstname: "Numéro Iconnu",
               client_phone_number: value,
              })}
            />
            {userRole && userRole >= userRoles.SUPER_ADMIN && (
              <OrganizationPicker
                label="Organisation"
                setOrganization={setOrganisationFilter}
                currentOrganization={organisationFilter}
                style={{ height: 35, width: 250 }}
              />
            )}
          </FilterDrawerContainer>
        )}
        filterStatusRender={
          currentFilterObject?.paygo_client_phone_number?.values[0] ||
          currentFilterObject?.paygo_station?.values[0] ||
          currentFilterObject?.organization_id?.values[0]
            ? () => (
                <>
                  {currentFilterObject?.paygo_station?.values[0] && (
                    <FilterStatusItem
                      labelRender={() => (
                        <SingleStation.StationInfo
                          stationId={
                            currentFilterObject?.paygo_station
                              ?.values[0] as string
                          }
                          info="station_name"
                        />
                      )}
                      onClickDelete={() => {
                        removeFromFilter(["paygo_station"]);
                        setStationFilter(undefined);
                      }}
                    />
                  )}
                  {currentFilterObject?.paygo_client_phone_number?.values[0] && (
                    <FilterStatusItem
                      labelRender={() => (
                        <>
                          {
                            currentFilterObject?.paygo_client_phone_number
                              ?.values[0]
                          }
                        </>
                      )}
                      onClickDelete={() => {
                        removeFromFilter(["paygo_client_phone_number"]);
                        setUserFilter(undefined);
                      }}
                    />
                  )}
                  {currentFilterObject?.organization_id?.values[0] && (
                    <FilterStatusItem
                      labelRender={() => (
                        <SingleOrganization.Info
                          id={
                            currentFilterObject?.organization_id
                              ?.values[0] as string
                          }
                          info="organization_name"
                        />
                      )}
                      onClickDelete={() => {
                        removeFromFilter(["organization_id"]);
                        setOrganisationFilter(undefined);
                      }}
                    />
                  )}
                </>
              )
            : undefined
        }
      />
    </div>
  );
}
